import TransparentCharacterImage from './TransparentCharacterImage';
import PraamisOrb from './PraamisOrb';
import { isPraamis } from '../lib/praamisIdentity';
import type { CharacterProfile } from '../types';
import BookwormApprovedArt from './BookwormApprovedArt';
import {robotColorFilter} from '../character/robotPalette';
import {getRobotVariant,getRolePreviewVariant} from '../character/robotGallery';
import {characterFamilyKey,layerTransform,resolveLayer,selectedLayers} from '../character/manifest';

type Props = {profile?:CharacterProfile|null; name:string; roleKey?:string; status?:string; size?:number; className?:string};

export default function AgentCharacterAvatar({profile,name,roleKey,status,size=48,className=''}:Props){
  if (isPraamis({official_name:name,role_key:roleKey}) && !profile) return <span className={'agent-portrait praamis-portrait '+className} style={{width:size,height:size,flex:'0 0 '+size+'px'}} role="img" aria-label="Executive operating agent avatar"><PraamisOrb size={size}/></span>;
  const base=profile?.base_type;
  const appearance=profile?.appearance||{};
  const family=base?characterFamilyKey(base,appearance):'default_agent';
  const riggedPortrait=(base==='human'||base==='bear');
  const layers=base==='human'||base==='bear'?selectedLayers(base,appearance):[];
  const expressionLayers=riggedPortrait?(['eyes','mouth'] as const).map(type=>resolveLayer(family,type,'friendly')).filter(layer=>layer!==null):[];
  const characterLayers=[...layers,...expressionLayers].sort((a,b)=>a.z_index-b.z_index);
  const feminine=profile?.appearance?.gender==='Feminine';
  const label=name+' character portrait';
  const color=profile?.appearance?.accentColor||'Green';
  const fallbackSrc=feminine?'/character-assets/default-agent-female.webp':'/character-assets/default-agent-male.webp';
  const selected=getRobotVariant(profile?.appearance?.robotVariantId);
  const suggested=!profile?getRolePreviewVariant(roleKey,name):undefined;
  const portrait=selected&&!selected.requiresBrandCleanup?selected:suggested;
  const src=portrait?.src||fallbackSrc;
  return (
    <span className={'agent-portrait '+className} style={{width:size,height:size,flex:'0 0 '+size+'px'}} role="img" aria-label={label}>
      {(!base || base==='default_agent') ? (
        <TransparentCharacterImage src={src} fallbackSrc={fallbackSrc} alt="" className="agent-portrait-img" style={{filter:portrait?undefined:robotColorFilter(color)}} loading="lazy" draggable={false}/>
      ) : base==='library_animal' && profile?.appearance?.species==='Owl' ? (
        <img src="/character-assets/owl-approved-static.webp" alt="" className="agent-portrait-img" loading="lazy" draggable={false}/>
      ) : base==='bookworm' ? (
        <span className="agent-portrait-bookworm"><BookwormApprovedArt appearance={profile?.appearance?.autoWorkGlasses ? {...profile.appearance,eyewear:/^working$/i.test(status||'')?'On':'Off'} : (profile?.appearance||{})}/></span>
      ) : riggedPortrait ? (
        <svg viewBox="0 0 320 360" width={size} height={size} style={{display:'block',width:'100%',height:'100%',overflow:'visible'}} aria-hidden="true">
          {characterLayers.map((layer,index)=>(
            <svg key={layer.layer_file+':'+layer.option_type+':'+index} width="320" height="360" viewBox="0 0 320 360"
              style={{color:layer.color||'#9aabb7'}}>
              <use href={layer.layer_file} transform={layerTransform(family,layer,appearance.gender)}/>
            </svg>
          ))}
        </svg>
      ) : (
        <TransparentCharacterImage src={fallbackSrc} alt="" className="agent-portrait-img" loading="lazy" draggable={false}/>
      )}
    </span>
  );
}

